import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
// import useGet from "./useGet";
import useUpdate from "./useUpdate";
import SuperOrderForm from "@beeldit/ecommerce/super-orders/components/SuperOrderForm";
import {EditObservationsActionContext} from "@beeldit/ecommerce/super-orders/actions/edit-observations/EditObservationsActionContext";

function useEditObservationsAction(onSuccess: any): any {

  // const get = useGet();
  // const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    onSuccess(); // We pass the function to refresh the table on success
  };

  const showModalObservations = (element: any) => {
    setElement(element);
    element.observation_form = true;
    element.billing_address_form = false;
    element.shipping_address_form = false;  
    setShowModal(true);
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  const contextInstance = useContext(EditObservationsActionContext);
  const { element, setElement, setShowModal } = contextInstance;


  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "observations",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-lg",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: EditObservationsActionContext,
    action: 'edit',
    className: "super-order-form",
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <SuperOrderForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    showModalObservations,
    actionTemplate,
  };
}

export default useEditObservationsAction;
